module.exports = __webpack_public_path__ + "img/heading2.97ed216d.jpg";